module.exports = __webpack_public_path__ + "img/深圳金融科技研究院.837c20f9.png";